<template>
  <div data-component="Widget/Checkbox">
    <input 
      type="checkbox" 
      :id="id" 
      v-bind="$attrs"
      :value="modelValue"
      :disabled="readOnly"
      @input="$emit('update:modelValue', $event.target.checked)"
    />
    <label :for="id"></label>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Checkbox',
  props: {
    id: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue']
}
</script>

<style lang="scss" scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
